import { getPreferences, setPreferences } from '@sas/nova-core/services/preferences';
import { RequestParamLimit } from '../../../../../../../../rest/viya-sonder/rest/paging';
import { GO_MAX_INT16 } from '../../catalog/access/catalogServiceAccessorREST';

// PreferenceKeySearchesFree is the key for catalog's saved searches
const PreferenceKeySearchesFree = 'SASInformationCatalog.searches.free';

// GetPreviousSearches - get all previous searches from preferences
export const GetPreviousSearches = async () => {
  const allUserPreferences = await getPreferences({
    params: {
      [RequestParamLimit]: GO_MAX_INT16
    }
  });
  const savedSearchPref = filterUserPrefs(allUserPreferences, PreferenceKeySearchesFree);
  if (savedSearchPref) {
    return JSON.parse(savedSearchPref);
  }
  return null;
};
export const SetPreviousSearches = async searches => {
  const userPreferences = await setPreferences([{
    id: PreferenceKeySearchesFree,
    value: JSON.stringify(searches)
  }]);
  const updatedPreferenceValue = filterUserPrefs(userPreferences, PreferenceKeySearchesFree);
  if (updatedPreferenceValue) {
    return JSON.parse(updatedPreferenceValue);
  }
  return null;
};
const filterUserPrefs = (userPreferences, key) => {
  let matchingPreference;
  for (const userPref of userPreferences.items) {
    if (userPref.id === key) {
      matchingPreference = userPref.value;
      break;
    }
  }
  return matchingPreference;
};
//# sourceMappingURL=preferencesServiceAccessorREST.js.map